import React, { useState } from "react";
import { Link } from "react-router-dom";

const PageHeader = ({ title, previousPageTitle, actions = [], description }) => {
  const [showGuide, setShowGuide] = useState(false);

  return (
    <div className="page-header">
      <div>
        <h2 className="main-content-title tx-24 mg-b-5">
          {previousPageTitle ?? "Accountify"}
          {description && (
            <button
              className="btn btn-sm btn-icon ms-2"
              title="Page Guide"
              onClick={() => setShowGuide((v) => !v)}
              style={{ background: "none", border: "none", color: "var(--primary)", verticalAlign: "middle" }}
            >
              <i className="fa-solid fa-circle-info" style={{ fontSize: "1rem" }}></i>
            </button>
          )}
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/" style={{ color: "royalblue", textDecoration: "none" }}>
              <i className="fa-solid fa-house" style={{ marginRight: "6px" }}></i>
              Home
            </Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {title}
          </li>
        </ol>
        {description && showGuide && (
          <div className="alert alert-info mt-2 p-2" style={{ fontSize: "0.85rem", borderRadius: "6px" }}>
            <i className="fa-solid fa-lightbulb me-1"></i>
            {description}
          </div>
        )}
      </div>
      <div className="d-flex">
        <div className="justify-content-center">
          {actions.map((btn, index) => (
            <button
              key={index}
              className={(btn.className || "btn btn-primary") + " me-1 my-2"}
              onClick={btn.onClick}
              disabled={btn.disabled}
            >
              {btn.icon && <i className={`${btn.icon} mr-1`} />}
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
